module.exports = __webpack_public_path__ + "img/bouncecounter.91302286.png";